import Component from '@glimmer/component';
import { service } from '@ember/service';
import ReportViewPage from 'tio-reporting/components/report-view/page';
import type ReportViewerController from 'tio-employee/controllers/authenticated/admin/reporting/report-viewer';
import type RouterService from '@ember/routing/router-service';

interface ReportViewerRouteSignature {
  Args: {
    controller: ReportViewerController;
  };
}

class ReportViewerRouteComponent extends Component<ReportViewerRouteSignature> {
  @service declare router: RouterService;

  handleBack = () => {
    this.router.transitionTo('authenticated.admin.reporting');
  };

  <template>
    <ReportViewPage @controller={{@controller}} @viewedFrom="partner" @onBack={{this.handleBack}} />
  </template>
}

export default ReportViewerRouteComponent;
